module.exports = __webpack_public_path__ + "img/智慧校园.d10d28a5.png";